import {
    CLEAR_CRUD_APIKEY,
    GET_APIKEYS_REQUEST,
    GET_APIKEYS_SUCCESS,
    GET_APIKEYS_ERROR,
    GET_APIKEY_REQUEST,
    GET_APIKEY_SUCCESS,
    GET_APIKEY_ERROR,
    GET_APIKEYS_FTP_REQUEST,
    GET_APIKEYS_FTP_SUCCESS,
    GET_APIKEYS_FTP_ERROR,
    GET_APIKEYS_MAPS_REQUEST,
    GET_APIKEYS_MAPS_SUCCESS,
    GET_APIKEYS_MAPS_ERROR,
    GET_APIKEYS_USAGE_PLANS_REQUEST,
    GET_APIKEYS_USAGE_PLANS_SUCCESS,
    GET_APIKEYS_USAGE_PLANS_ERROR,
    GET_APIKEYS_EXTERNAL_PROVIDERS_REQUEST,
    GET_APIKEYS_EXTERNAL_PROVIDERS_SUCCESS,
    GET_APIKEYS_EXTERNAL_PROVIDERS_ERROR,
    DELETE_APIKEY_SUCCESS,
    DELETE_FTPUSER_SUCCESS,
    SET_APIKEYS_ACTIVE_TAB,
} from 'constants/ActionTypes';

const initialState = {
    list: [],
    listLoading: false,
    listError: false,

    currentApiKey: null,
    currentApiKeyLoading: false,
    currentApiKeyError: false,

    ftpUser: null,
    ftpUserLoading: false,
    ftpUserError: false,

    usagePlans: null,
    usagePlansLoading: false,
    usagePlansError: false,

    externalProviders: null,
    externalProvidersLoading: false,
    externalProvidersError: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        // Get api keys list
        case GET_APIKEYS_REQUEST:
            return {
                ...state,
                listLoading: true,
                listError: false,
            };

        case GET_APIKEYS_SUCCESS: {
            return {
                ...state,
                list: action.payload,
                listLoading: false,
                listError: false,
            };
        }

        case GET_APIKEYS_ERROR:
            return {
                ...state,
                listLoading: false,
                listError: true,
            };

        // Get api key
        case GET_APIKEY_REQUEST:
            return {
                ...state,
                currentApiKeyLoading: true,
                currentApiKeyError: false,
            };

        case GET_APIKEY_SUCCESS:
            return {
                ...state,
                currentApiKeyLoading: false,
                currentApiKey: action.payload,
                currentApiKeyError: false,
            };

        case GET_APIKEY_ERROR:
            return {
                ...state,
                currentApiKeyLoading: false,
                currentApiKey: null,
                currentApiKeyError: true,
            };

        // Get FTP user
        case GET_APIKEYS_FTP_REQUEST:
            return {
                ...state,
                ftpUserLoading: true,
                ftpUserError: false,
            };

        case GET_APIKEYS_FTP_SUCCESS:
            return {
                ...state,
                ftpUserLoading: false,
                ftpUser: action.payload,
                ftpUserError: false,
            };

        case GET_APIKEYS_FTP_ERROR:
            return {
                ...state,
                ftpUserLoading: false,
                ftpUser: null,
                ftpUserError: true,
            };

        // Get MAPS keys
        case GET_APIKEYS_MAPS_REQUEST:
            return {
                ...state,
                mapsListLoading: true,
                mapsListError: false,
            };

        case GET_APIKEYS_MAPS_SUCCESS:
            return {
                ...state,
                mapsList: action.payload,
                mapsListLoading: false,
                mapsListError: false,
            };

        case GET_APIKEYS_MAPS_ERROR:
            return {
                ...state,
                mapsListLoading: false,
                mapsListError: true,
            };

        // Delete api key
        case DELETE_APIKEY_SUCCESS:
            return {
                ...state,
            };

        // Get usage plans
        case GET_APIKEYS_USAGE_PLANS_REQUEST:
            return {
                ...state,
                usagePlansLoading: true,
                usagePlansError: false,
            };

        case GET_APIKEYS_USAGE_PLANS_SUCCESS:
            return {
                ...state,
                usagePlansLoading: false,
                usagePlans: action.payload,
                usagePlansError: false,
            };

        case GET_APIKEYS_USAGE_PLANS_ERROR:
            return {
                ...state,
                usagePlansLoading: false,
                usagePlans: null,
                usagePlansError: true,
            };

        // Get external providers
        case GET_APIKEYS_EXTERNAL_PROVIDERS_REQUEST:
            return {
                ...state,
                externalProvidersLoading: true,
                externalProvidersError: false,
            };

        case GET_APIKEYS_EXTERNAL_PROVIDERS_SUCCESS:
            return {
                ...state,
                externalProvidersLoading: false,
                externalProviders: action.payload,
                externalProvidersError: false,
            };

        case GET_APIKEYS_EXTERNAL_PROVIDERS_ERROR:
            return {
                ...state,
                externalProvidersLoading: false,
                externalProviders: null,
                externalProvidersError: true,
            };

        // Delete ftp user
        case DELETE_FTPUSER_SUCCESS:
            return {
                ...state,
            };

        // Clear loaded key into crud
        case CLEAR_CRUD_APIKEY:
            return {
                ...state,
                currentApiKey: null,
            };

        // Tabs
        case SET_APIKEYS_ACTIVE_TAB:
            return {
                ...state,
                activeTab: action.payload.activeTab,
            };

        default:
            return {
                ...state,
            };
    }
}
